import { transformEmailThemeToBuilderUI } from "@/react/types/EmailTheme";
import type { MarketingEmailTemplate } from "@/react/types/MarketingEmailTemplates";
import { BuilderUI } from "../../../BuilderUI";
import { createBlockRendererMapping } from "../../../BuilderUI/Helpers/blockMappings";
import { BlockRenderer } from "../../../BuilderUI/Renderer/BlockRenderer";
import { BroadcastTipTapReadonlyView } from "../../EmailPreview/BroadcastTipTapReadonlyView";
import { blocks } from "../../VisualEmailBuilder/Blocks";
import { GooberContextProvider } from "../../VisualEmailBuilder/Design/GooberContext";
import { DEFAULT_THEME } from "../../VisualEmailBuilder/Design/defaultTheme";
import { EmailFrame } from "../../VisualEmailBuilder/EmailFrame";
import { useIsVisualEmailBuilderThemesEnabled } from "../../VisualEmailBuilder/hooks/useIsVisualEmailBuilderThemesEnabled";

const components = createBlockRendererMapping(blocks);

export const CardPreview = ({
  template,
}: {
  template: MarketingEmailTemplate;
}) => {
  const isThemesEnabled = useIsVisualEmailBuilderThemesEnabled();
  const theme =
    isThemesEnabled && template.email_theme
      ? transformEmailThemeToBuilderUI(template.email_theme)
      : DEFAULT_THEME;

  if (template.content_type === "tip_tap_email") {
    return <BroadcastTipTapReadonlyView content={template.content} />;
  }
  return (
    <BuilderUI.Provider
      theme={theme}
      block={template.visual_email_builder_content.content}
      inlineAttachments={
        template.visual_email_builder_content.inline_attachments
      }
      canvasSize="tablet"
    >
      <EmailFrame>
        <GooberContextProvider>
          <BlockRenderer
            components={components}
            block={template.visual_email_builder_content.content}
          />
        </GooberContextProvider>
      </EmailFrame>
    </BuilderUI.Provider>
  );
};
